import { Route } from 'react-router-dom';
import React, { Suspense, lazy, Fragment } from 'react';
import Loader from 'react-loaders';

import { ToastContainer } from 'react-toastify';

const Pages = lazy(() => import('../../Application/Pages'));

function AppMain() {
  return (
    <>
      {/* Pages */}
      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-grid-beat" />
              </div>
              {/* <h6 className="mt-3">Please wait while we load the Application</h6> */}
            </div>
          </div>
        }
      >
        <Route path="/" component={Pages} />
      </Suspense>

      {/* <Route exact path="/" render={() => (<Redirect to="/" />)} /> */}

      <ToastContainer />
    </>
  );
}

export default AppMain;
